var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconExchange = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 19.3334L11.6667 19.3334C9.8986 19.3334 8.2029 18.631 6.95266 17.3808C5.70242 16.1306 5.00004 14.4349 5.00004 12.6667L5.00004 8.66675M5.00004 8.66675L9.00004 12.6667M5.00004 8.66675L1.00004 12.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 0.666747L14.3333 0.666748C16.1014 0.666748 17.7971 1.36913 19.0474 2.61937C20.2976 3.86961 21 5.5653 21 7.33341L21 11.3334M21 11.3334L25 7.33341M21 11.3334L17 7.33341",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconExchange, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_exchange.76fb14ea.svg";
export { ForwardRef as ReactComponent };